<h2 mat-dialog-title>
  {{ data.title ? (data.title | translate) : (title | translate) }}
</h2>

<mat-dialog-content>
  <form [formGroup]="formDataGroup" #form="ngForm">
    <div class="form-row">
      <div class="m-form col-md-12 form-group pl-0 pr-0">
        <label class="required">
          {{ "public.assign_dialog.receiver_lbl" | translate }}
          ({{ "public.assign_dialog.office" | translate }})
        </label>
        <app-select
          [enableSearch]="true"
          formControlName="to_department"
          (listScroll)="onDepartmentListScroll($event)"
          (searchSubmit)="onDepartmentSearchChange($event)"
          (selectChange)="onDepartmentSelectChange($event)"
        >
          <app-option
            *ngFor="let department of departments"
            [value]="department._id"
          >
            {{
              lang != LANG.EN || !department.name_en
                ? department.name_kh
                : department.name_en
            }}
          </app-option>
        </app-select>
      </div>
      <div class="m-form col-md-12 form-group pl-0 pr-0">
        <label [ngClass]="{ required: data?.required }">
          {{ "public.assign_dialog.receiver_lbl" | translate }}
          ({{ "public.assign_dialog.receiver" | translate }})
        </label>
        <app-select
          formControlName="to_user"
          [enableSearch]="true"
          (searchSubmit)="onUserSearch($event)"
        >
          <app-option *ngFor="let user of users" [value]="user._id">
            {{ getUserName(user) }}
          </app-option>
        </app-select>
      </div>
      <div class="m-form col-md-12 form-group pl-0 pr-0">
        <label>{{ "public.reason" | translate }}</label>
        <textarea
          formControlName="description"
          type="text"
          class="form-control"
          style="height: auto"
          rows="4"
        ></textarea>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="m-button-outlined">
    <mat-icon style="transform: rotateY(180deg)">logout</mat-icon
    >{{ "button.cancel" | translate }}
  </button>
  <button
    mat-raised-button
    class="m-button-primary"
    [disabled]="!formDataGroup.valid"
    (click)="onSubmit()"
  >
    <mat-icon>save</mat-icon>{{ "button.submit" | translate }}
  </button>
</mat-dialog-actions>
